/*
A Vue 3 app, built using custom components

Vue 3: https://vuejs.org/guide/introduction.html (select 'Composition' as your API preference)

Build tasks:
npm run build

Watch task:
npm run watch

Config file:
vite.config.illinois-made.js
*/
import { createApp } from 'vue';
import { createHead } from 'unhead';
import App from './illinoisMade/App.vue';

createApp(App)
    .use(createHead())
    .mount('.js-illinois-made-block');
